import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getAllCategories = async (locationId) => {
  const response = await axiosInstance.get(API.CATEGORY.ALL_CATEGORIES + locationId);
  return response;
};
export const addCategory = async (body) => {
  const response = await axiosInstance.post(API.CATEGORY.ADD_CATEGORY, body);
  return response;
};
export const updateCategory = async (body) => {
  const response = await axiosInstance.patch(API.CATEGORY.UPDATE_CATEGORY, body);
  return response;
};
export const deleteCategory = async (id) => {
  const response = await axiosInstance.delete(API.CATEGORY.DELETE_CATEGORY + id);
  return response;
};
